import styled from "styled-components";

export const EventsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgb(40,44,52);
  background: linear-gradient(360deg, rgba(40,44,52,1) 25%, rgba(0,0,1,1) 75%);
  margin-top: 4em;
  padding: 8em 0;
`